export default {"src":"/_next/static/image/public/images/ic_guest_family.5a06fcc588950d0d9f22ed5f3a3f98e3.svg","height":154,"width":197};